export default __webpack_public_path__ + "media/images/3-25d4b1a0c883a4bfada2f4d3071b55ad.jpg";